export function getSafeQrCodeErrorMessage(err: unknown): string {
  const message = getErrorMessage(err);
  const normalized = message.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  if (
    normalized.includes('solicitacao nao esta pendente') ||
    normalized.includes('solicitacao expirada') ||
    normalized.includes('handoff expirado') ||
    normalized.includes('handoff ja utilizado')
  ) {
    return '';
  }

  if (/not valid JSON|unexpected token/i.test(message)) {
    return 'Nao foi possivel gerar o QR seguro agora. Use e-mail ou liberacao ao superior.';
  }

  return message || 'Falha ao gerar QR seguro.';
}

export function getSafeApprovalErrorMessage(err: unknown): string {
  const message = getErrorMessage(err);
  const normalized = message.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  if (
    normalized.includes('solicitacao nao esta pendente') ||
    normalized.includes('solicitacao expirada') ||
    normalized.includes('handoff invalido') ||
    normalized.includes('handoff expirado') ||
    normalized.includes('handoff ja utilizado') ||
    normalized.includes('qr encerrado')
  ) {
    return '';
  }

  return message;
}

function getErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return '';
}
